export enum ActionType {
  question,
  answer,
  review,
  vote,
}

export const defaultActionPermission = { review: false, question: false, answer: false, vote: false };
